<template>
  <app-page>
    <div id="wrap">
      <h2 class="h2">研发费用加计扣除</h2>
      <div class="header_box">
        <span class="span_btn">政策依据</span>
        <el-dropdown trigger="click" placement="bottom">
          <span class="el-dropdown-link">
            关于完善研究开发费用税前加计扣除政策的通知
            <i class="el-icon-arrow-down el-icon--right"></i>
          </span>
          <template #dropdown>
            <el-dropdown-menu>
              <el-dropdown-item @click.native="expendpolicy_a()"
                >关于完善研究开发费用税前加计扣除政策的通知</el-dropdown-item
              >
              <el-dropdown-item @click.native="expendpolicy_b()"
                >关于企业研究开发费用税前加计扣除政策有关问题的公告</el-dropdown-item
              >
              <el-dropdown-item @click.native="expendpolicy_c()"
                >关于提高科技型中小企业研究开发费用税前加计扣除比例的通知</el-dropdown-item
              >
              <el-dropdown-item @click.native="expendpolicy_d()"
                >中华人民共和国企业所得税法实施条例</el-dropdown-item
              >
              <el-dropdown-item @click.native="expendpolicy_e()"
                >国家税务总局关于研发费用税前加计扣除归集范围有关问题的公告</el-dropdown-item
              >
              <el-dropdown-item @click.native="expendpolicy_f()"
                >财政部、国家税务总局关于《中华人民共和国企业所得税法》公布后企业适用税收法律问题的通知</el-dropdown-item
              >
            </el-dropdown-menu>
          </template>
        </el-dropdown>
        <div class="zice_btn" @click="typefn()">
          <span @click="centerDialogFn()"
            >立即自测 <i class="iconfont icon-arrow-right-copy-copy"></i
          ></span>
        </div>
      </div>

      <el-dialog
        custom-class="dialog"
        :title="dialogTitle"
        :visible.sync="dialogVisible"
        width="26%"
        center
        @close="dialogType = 0"
      >
        <template v-if="dialogType === 1">
          <div class="text_box">
            根据您的数据，您的匹配度为:
            <h2 class="title" style="display: inline" id="status">
              {{ status }}
            </h2>
          </div>
          <br />
          <div class="flex flex-center">
            <img src="@images/icon/res.png" alt="" />
          </div>
          <h2 class="title" style="text-align: center" id="msg1">
            {{ msg1 }}
          </h2>
          <div
            id="msg2"
            class="subtitle pointer wrap"
            style="
              text-align: center;
              margin-top: 15px;
              line-height: normal;
              white-space: pre-wrap !important;
            "
          >
            {{ msg2 }}
          </div>
          <br />
          <div style="font-size: 12px">
            <span style="color: red">温馨提示:</span>
            <span style="color: darkgray; line-height: 15px"
              >政策自测结果仅供参考，请申报单位参考当地申报通知进行申报</span
            >
          </div>
        </template>
        <template v-else>
          <div class="flex flex-center zice_gif">
            <img src="@images/icon/zice.gif" />
          </div>
        </template>
        <template #footer>
          <template v-if="dialogType === 0"></template>
          <template v-else>
            <span class="dialog-footer">
              <el-button type="primary" @click="dialogVisible = false"
                >确认</el-button
              >
            </span>
          </template>
        </template>
      </el-dialog>

      <div class="title_box">
        <span class="backg">!</span>
        <span>带*的信息尤为重要,严重影响自测结果,请您务必填写!</span>
      </div>
      <div class="answer">
        <div class="item_box">
          <div class="topic">
            <span class="color">*</span>
            <span>1，企业法人资格（单选）</span>
          </div>
          <div class="item">
            <el-radio
              v-for="item in topic1"
              :key="item.value"
              :label="item.value"
              border
              v-model="radio1"
              @change="changefn1"
              >{{ item.label }}</el-radio
            >

            <!--            <el-radio-group v-model="radio1" @change="changefn1">-->
            <!--              <el-radio-->
            <!--                v-for="item in topic1"-->
            <!--                :key="item.value+1"-->
            <!--                :label="item.value"-->
            <!--                border-->
            <!--                @change="changefn1"-->
            <!--              >{{ item.label }}</el-radio>-->
            <!--            </el-radio-group>-->
            <!--            <el-radio-group v-model="radio">-->
            <!--              <el-radio :label="3">备选项</el-radio>-->
            <!--              <el-radio :label="6">备选项</el-radio>-->
            <!--              <el-radio :label="9">备选项</el-radio>-->
            <!--            </el-radio-group>-->
          </div>
          <div
            class="title"
            :style="{ color: radio1 == 0 ? '#4988df' : 'red' }"
          >
            {{ text1 }}
          </div>
        </div>
        <!--  -->
        <div class="item_box">
          <div class="topic">
            <span class="color">*</span>
            <span>2，申报单位所属行业类别(单选)</span>
          </div>
          <div class="item">
            <el-radio
              v-for="item in topic2"
              :key="item.value"
              :label="item.value"
              border
              v-model="radio2"
              @change="changefn2"
              >{{ item.label }}</el-radio
            >
          </div>
          <div
            class="title"
            :style="{ color: radio2 == 7 ? '#4988df' : 'red' }"
          >
            {{ text2 }}
          </div>
        </div>
        <div class="item_box">
          <div class="topic">
            <span class="color">*</span>
            <span>3，申报单位开展研发活动的类型(单选) </span>
          </div>
          <div class="item">
            <el-radio
              v-for="item in topic3"
              :key="item.value"
              :label="item.value"
              border
              v-model="radio3"
              @change="changefn3"
              >{{ item.label }}</el-radio
            >
          </div>
          <div
            class="title"
            :style="{ color: radio3 == 7 ? '#4988df' : 'red' }"
          >
            {{ text3 }}
          </div>
        </div>
        <div class="item_box">
          <div class="topic">
            <span class="color">*</span>
            <span
              >4，申报单位是否按照财务会计制度要求,对研发支出进行会计处理(单选)</span
            >
          </div>
          <div class="item">
            <el-radio
              v-for="item in topic4"
              :key="item.value"
              :label="item.value"
              border
              v-model="radio4"
              @change="changefn4"
              >{{ item.label }}</el-radio
            >
          </div>
          <div
            class="title"
            :style="{ color: radio4 == 0 ? '#4988df' : 'red' }"
          >
            {{ text4 }}
          </div>
        </div>
        <div class="item_box">
          <div class="topic">
            <span class="color">*</span>
            <span
              >5，申报单位是否对享受加计扣除的研发费用按研发项目设置辅助账(单选)</span
            >
          </div>
          <div class="item">
            <el-radio
              v-for="item in topic5"
              :key="item.value"
              :label="item.value"
              border
              v-model="radio5"
              @change="changefn5"
              >{{ item.label }}</el-radio
            >
          </div>
          <div
            class="title"
            :style="{ color: radio5 == 0 ? '#4988df' : 'red' }"
          >
            {{ text5 }}
          </div>
        </div>
        <div class="item_box">
          <div class="topic">
            <span class="color">*</span>
            <span
              >6，申报单位在一个纳税年度内的研发项目数量和归集可加计扣除的研发费用的状况(单选)</span
            >
          </div>
          <div class="item">
            <el-radio
              v-for="item in topic6"
              :key="item.value"
              :label="item.value"
              border
              v-model="radio6"
              @change="changefn6"
              >{{ item.label }}</el-radio
            >
          </div>
          <div
            class="title"
            :style="{ color: radio6 != 2 ? '#4988df' : 'red' }"
          >
            {{ text6 }}
          </div>
        </div>
        <div class="item_box">
          <div class="topic">
            <span class="color">*</span>
            <span
              >7，申报单位是否对研发费用和生产经营费用分别核算,准确、合理归集各项费用支出(单选)</span
            >
          </div>
          <div class="item">
            <el-radio
              v-for="item in topic7"
              :key="item.value"
              :label="item.value"
              border
              v-model="radio7"
              @change="changefn7"
              >{{ item.label }}</el-radio
            >
          </div>
          <div
            class="title"
            :style="{ color: radio7 == 0 ? '#4988df' : 'red' }"
          >
            {{ text7 }}
          </div>
        </div>
        <div class="item_box">
          <div class="topic">
            <span class="color">*</span>
            <span>8，申报单位在委托研发活动中,属于（单选)</span>
          </div>
          <div class="item">
            <el-radio
              class=""
              v-for="item in topic8"
              :key="item.value"
              :label="item.value"
              border
              v-model="radio8"
              @change="changefn8"
              >{{ item.label }}</el-radio
            >
          </div>
          <div
            class="title"
            :style="{ color: radio8 == 0 || radio8 == 1 ? '#4988df' : 'red' }"
          >
            {{ text8 }}
          </div>
        </div>
      </div>
      <div class="flex flex-center">
        <div class="zice_btn" @click="typefn()">
          <span @click="centerDialogFn()"
            >立即自测 <i class="iconfont icon-arrow-right-copy-copy"></i
          ></span>
        </div>
      </div>
    </div>
  </app-page>
</template>
<script>
import AppPage from "@/components/semantics/AppPage.vue";
export default {
  components: { AppPage },
  data() {
    return {
      msg1: "",
      msg2: "",
      form: {
        region: "1",
      },
      accordScore: 80,
      status: "",
      dialogVisible: false,
      dialogType: 0,
      dialogTitle: "",
      topic1: [
        { value: 0, label: "具有独立法人资格" },
        { value: 1, label: "不具有独立法人资格" },
      ],
      topic2: [
        { value: 0, label: "烟草制造业" },
        { value: 1, label: "住宿和餐饮业" },
        { value: 2, label: "批发和零售业" },
        { value: 3, label: "房地产业" },
        { value: 4, label: "租赁和商务服务业" },
        { value: 5, label: "娱乐业" },
        {
          value: 6,
          label: "财政部和国家税务总局规定的其他不适用税前加计扣除政策的行业",
        },
        { value: 7, label: "以上皆不是" },
      ],
      topic3: [
        { value: 0, label: "企业产品(服务)的常规性升级" },
        {
          value: 1,
          label:
            "对某项科研成果的直接应用,如直接采用公开的新工艺、材料、装置、产品、服务或知识等",
        },
        { value: 2, label: "企业在商品化后为顾客提供的技术支持活动" },
        {
          value: 3,
          label: "对现存产品、服务、技术、材料或工艺流程进行的重复或简单改变",
        },
        { value: 4, label: "市场调查研究、效率调查或管理研究" },
        {
          value: 5,
          label: "作为工业(服务)流程环节或常规的质量控制、测试分析、维修维护",
        },
        { value: 6, label: "社会科学、艺术或人文学方面的研究" },
        { value: 7, label: "以上皆不是" },
      ],
      topic4: [
        { value: 0, label: "是" },
        { value: 1, label: "否" },
      ],
      topic5: [
        { value: 0, label: "是" },
        { value: 1, label: "否" },
      ],
      topic6: [
        {
          value: 0,
          label:
            "企业在一个纳税年度内仅进行一项研发活动,并准确归集可加计扣除的研发费用",
        },
        {
          value: 1,
          label:
            "企业在一个纳税年度内进行多项研发活动,并按照不同研发项目分别归集可加计扣除的研发费用",
        },
        { value: 2, label: "以上情形均无" },
      ],
      topic7: [
        { value: 0, label: "是" },
        { value: 1, label: "否" },
      ],
      topic8: [
        {
          value: 0,
          label: "自主研发",
        },
        {
          value: 1,
          label: "委托方",
        },
        { value: 2, label: "受托方" },
      ],
      radio: 3,
      // 单选框
      radio1: 9,
      radio2: 9,
      radio3: 9,
      radio4: 9,
      radio5: 9,
      radio6: 9,
      radio7: 9,
      radio8: 9,
      // 提示信息
      text1: "",
      text2: "",
      text3: "",
      text4: "",
      text5: "",
      text6: "",
      text7: "",
      text8: "",
      time: "",
    };
  },
  created() {
    this.totalPoints();
  },
  methods: {
    toService() {
      this.$router.push({
        path: "/detail/market",
        query: {
          goodId: "825d8eb0957b4a44927196b63818e8a2",
        },
      });
    },
    // 自测弹出框
    centerDialogFn() {
      if (
        this.radio1 == 9 ||
        this.radio2 == 9 ||
        this.radio3 == 9 ||
        this.radio4 == 9 ||
        this.radio5 == 9 ||
        this.radio6 == 9 ||
        this.radio7 == 9 ||
        this.radio8 == 9
      ) {
        this.$message.error("请将带*的题目填写完成");
      } else {
        this.typefn();
        this.dialogTitle = "计算中";
        this.dialogVisible = true;
        this.dialogType = 0;
        this.time = setTimeout(this.timer, 3000);
      }
    },
    timer: function () {
      this.dialogTitle = "自测结果";
      this.dialogType = 1;
    },

    expendpolicy_a: function () {
      this.$router.push("/pcm/expendpolicy_a");
    },
    expendpolicy_b: function () {
      this.$router.push("/pcm/expendpolicy_b");
    },
    expendpolicy_c: function () {
      this.$router.push("/pcm/expendpolicy_c");
    },
    expendpolicy_d: function () {
      this.$router.push("/pcm/expendpolicy_d");
    },
    expendpolicy_e: function () {
      this.$router.push("/pcm/expendpolicy_e");
    },
    expendpolicy_f: function () {
      this.$router.push("/pcm/expendpolicy_f");
    },
    totalPoints: function () {
      console.log(this.accordScore);
    },
    typefn: function () {
      this.accordScore = 80;
      if (this.radio1 == 1) {
        this.accordScore = parseInt(this.accordScore - 110);
      }
      if (this.radio2 != 7) {
        this.accordScore = parseInt(this.accordScore - 110);
      }
      if (this.radio3 != 7) {
        this.accordScore = parseInt(this.accordScore - 110);
      }
      if (this.radio4 == 1) {
        this.accordScore = parseInt(this.accordScore - 110);
      }
      if (this.radio5 == 1) {
        this.accordScore = parseInt(this.accordScore - 110);
      }
      if (this.radio6 == 2) {
        this.accordScore = parseInt(this.accordScore - 110);
      }
      if (this.radio7 == 1) {
        this.accordScore = parseInt(this.accordScore - 110);
      }
      if (this.radio8 == 2) {
        this.accordScore = parseInt(this.accordScore - 110);
      }

      console.log(this.accordScore);
      if (this.accordScore > 0) {
        this.status = "高";
        this.msg1 = "太棒了，恭喜您!";
        this.msg2 = "根据测评结果，建议申报！";
      } else {
        this.status = "低";
        this.msg1 = "再接再厉!";
        this.msg2 =
          "您的自测分值较低，未达到申报基本条件，尝试其他项目或完善信息吧！";
      }
    },
    changefn1: function (e) {
      console.log(this.radio1);
      if (e == 0) {
        this.text1 = "注:符合";
      } else if (e == 1) {
        this.text1 =
          "注: 不符合，不具有独立法人资格的申报单位，不是企业所得税纳税人，不能享受优惠。";
      }
    },
    changefn2: function (e) {
      console.log(e);
      if (e == "7") {
        this.text2 = "注: 符合";
      } else {
        this.text2 = "注: 不符合，本政策不适用该行业。";
      }
    },
    changefn3: function (e) {
      console.log(e);
      if (e == "7") {
        this.text3 = "注: 符合";
      } else {
        this.text3 = "注: 不符合，本政策不适用该活动。";
      }
    },
    changefn4: function (e) {
      console.log(e);
      if (e == "0") {
        this.text4 = "注: 符合";
      } else {
        this.text4 =
          "注: 不符合，该政策要求企业应有财务会计制度并对研发支出有相应的辅助账。";
      }
    },
    changefn5: function (e) {
      console.log(e);
      if (e == "0") {
        this.text5 = "注: 符合";
      } else {
        this.text5 =
          "注: 不符合，要求申报单位按研发项目设置辅助账，准确归集核算当年可加计扣除的各项研发费用实际发生额。";
      }
    },
    changefn6: function (e) {
      console.log(e);
      if (e == "2") {
        this.text6 =
          "注: 不符合，要求企业准确归集核算当年可加计扣除的各项研发费用实际发生额，在一个纳税年度内进行多项研发活动的，应按照不同研发项目分别归集可加计扣除的研发费用。";
      } else {
        this.text6 = "注: 符合";
      }
    },
    changefn7: function (e) {
      console.log(e);
      if (e == "0") {
        this.text7 = "注: 符合";
      } else {
        this.text7 =
          "注: 不符合，企业应对研发费用和生产经营费用分别核算，准确、合理归集各项费用支出，对划分不清的，不得实行加计扣除。";
      }
    },
    changefn8: function (e) {
      console.log(e);
      if (e == "2") {
        this.text8 = "注: 不符合，受托方不能享受该优惠。";
      } else {
        this.text8 = "注: 符合";
      }
    },
  },
};
</script>

<style scoped>
.h2 {
  color: #4988df;
  font-size: 24px;
  font-weight: bold;
  margin-bottom: 20px;
}
.header_box {
  padding-bottom: 20px;
  border-bottom: 2px solid #4988df;
}
.span_btn {
  padding: 5px;
  border: 1px solid #4988df;
  color: #4988df;
  margin-right: 10px;
}
.zice_btn {
  color: #fff;
  background: #4988df;
  padding: 8px 22px;
  border-radius: 3px;
  float: right;
}
.title_box {
  margin-top: 15px;
  padding: 10px;
  border: 1px solid #f8cf96;
  background: #fff9ec;
}
.title_box .backg {
  display: inline-block;
  width: 20px;
  height: 20px;
  text-align: center;
  line-height: 20px;
  border-radius: 50%;
  color: #fff;
  margin-right: 10px;
  background: #efc28a;
}
.answer {
  padding: 18px;
  font-size: 15px;
}
.answer .color {
  color: #d16963;
}
.answer .item {
  margin-left: 30px;
  /* margin-top: 15px; */
}
.answer .item_box {
  padding: 20px 0;
  border-bottom: 1px solid #dbdbdb;
}
.answer .el-button {
  margin-bottom: 10px;
}
.active {
  background-color: #d16963;
  color: #fff;
}
.answer .el-radio,
.answer .el-input,
.answer .el-checkbox {
  margin-top: 15px;
}
.title {
  margin: 15px 0 0 30px;
  color: #c40311;
}
.el-radio.is-bordered + .el-radio.is-bordered {
  margin-left: 0 !important;
}
/deep/.el-dialog__header {
  background: #4988df;
  padding: 20px 20px 10px;
}
/deep/.el-dialog__title {
  color: #fff;
}
/deep/.el-dialog__headerbtn .el-dialog__close {
  color: black;
}
</style>
<style lang="scss" scoped>
.app-img {
  position: relative;
  height: 220px;
  line-height: 220px;
  padding-left: 60px;
  width: 100%;
  background-image: url("~@/assets/images/bg/apply.png");
  background-size: 100% 100%;
}
.app-title {
  color: $white;
  margin-bottom: 30px;
  font-size: 36px;
}
.app-content {
  box-sizing: border-box;
  background: $white;
  z-index: 999;
  padding: 50px 100px;
  // margin-bottom: 30px;
}
</style>
